import pageView from './gtm/page-view';

export const gtmPageView = pageView;
